// Module
var code = "<p>BRCA Exchange primarily relies on the Hg38 build, though variant aliases from other genome builds are available to users in both views of the data.</p> ";
// Exports
module.exports = code;